import request from './request';

const drinks = {
	async getDrinks() {
		const response = await request.get('/app/drinks');
		return response;
	},
	async getDrinkCustomizations(query) {
		const response = await request.get('/app/drink-customizations', query);
		return response;
	}
};

export default drinks;
